export function NotFound() {
  return (
    <div className="container mt-1">
      <h1>Oops! page not found</h1>
    </div>
  );
}
